import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { PrivateRoute, PublicRoute } from "./PrivateRoute";

import Main from "../pages/main";
// import Category from "../pages/Category";
import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import PedidoNovo from "../pages/pedido/novo";
import RecuperarSenha from "../pages/auth/recuperar";
import NovaSenha from "../pages/auth/recuperar/nova";

import PedidoLista from "../pages/pedido/lista";
import PedidoDetalhe from "../pages/pedido/detalhe";
import PedidoFinalizados from "../pages/pedido/lista/finalizados";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<PrivateRoute />}>
          <Route exact path="/" element={<Main />} />
          <Route exact path="/pedido/novo" element={<PedidoNovo />} />
          <Route exact path="/pedido/todos" element={<PedidoLista />} />
          <Route
            exact
            path="/pedido/finalizados"
            element={<PedidoFinalizados />}
          />
          <Route exact path="/pedido/:id" element={<PedidoDetalhe />} />
        </Route>

        <Route exact path="/" element={<PublicRoute />}>
          <Route exact path="/auth/login" element={<Login />} />
          <Route exact path="/auth/cadastrar" element={<Register />} />
          <Route exact path="/auth/nova-senha" element={<NovaSenha />} />
          <Route
            exact
            path="/auth/recuperar-senha"
            element={<RecuperarSenha />}
          />
        </Route>

        {/* <Route exact path="/recovery-password" element={<RecoveryPassword/>}/> */}
        {/* <Route path="*" element={<NotFound/>}/> */}
      </Routes>
    </Router>
  );
};

export default App;

// export default function RouteList() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" exact component={Main} />

//         <Route path="/auth/login" exact component={Login} />

//         <Route path="/nobrand" exact component={() => <h1>Error 404</h1>} />

//         <Route path="/" component={() => <h1>Error 404</h1>} />
//       </Routes>
//     </BrowserRouter>
//   );
// }
